const e = [
  "before:block",
  "before:absolute",
  "before:left-0",
  "before:top-0",
  "before:w-100",
  "before:h-56",
  "before:bg-gradient-to-r",
  "before:from-white",
  "before:z-content-swimminglink"
], t = [
  "after:block",
  "after:absolute",
  "after:right-0",
  "after:top-0",
  "after:w-100",
  "after:h-56",
  "after:bg-gradient-to-l",
  "after:from-white"
];
export {
  e as FIRST_CLASS_LIST,
  t as LAST_CLASS_LIST
};
